<div class="article-search">
  <sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true"
      class="no-field-space article-selection-dialog">

      <sc-dialog-title>
        {{ 'Auswahl Artikel' | translate: ['erp.ui.articletype-selection.title', translationService.language]}}
      </sc-dialog-title>
      <sc-separator-line></sc-separator-line>

      <sc-padding>
        <form [formGroup]="formGroup">
          <sc-flex >
            <mat-form-field appearance="fill">
              <mat-label>{{ 'Search' | translate: ['erp.ui.articlesearch.query', translationService.language]}}</mat-label>
              <input matInput formControlName="query">
            </mat-form-field>
            <sc-content-spacer></sc-content-spacer>
            <button mat-stroked-button (click)="refreshArticleList()">
              <mat-icon><sc-icon iconClass="fa-refresh"></sc-icon></mat-icon>
              {{ 'Search' | translate: ['erp.ui.articlesearch.action.search', translationService.language]}}
            </button>
          </sc-flex>
        </form>
      </sc-padding>

      <sc-content-spacer [vertical]="true"></sc-content-spacer>


      <sc-padding>
          <div class="types-grid">
              <sc-bordered-tile *ngFor="let article of items"
              [style]="selected === article ? 'selected' : ''">
                  <sc-padding (click)="selectArticle(article)">
                    <div>{{article.identifier}}</div>
                      <!-- <app-dictionary-entry-label [model]="article.identifier"></app-dictionary-entry-label> -->
                  </sc-padding>
              </sc-bordered-tile>
          </div>
      </sc-padding>
      <sc-separator-line></sc-separator-line>
      <sc-actionbar>
          <sc-content-spacer [grow]="true"></sc-content-spacer>
          <button mat-stroked-button (click)="onClose()">
            {{ 'Abbrechen' | translate: ['erp.ui.articletype-selection.action.cancel', translationService.language]}}
          </button>
          <sc-content-spacer></sc-content-spacer>
          <button mat-flat-button (click)="onConfirm()" [disabled]="selected == null">
            {{ 'Übernehmen' | translate: ['erp.ui.articletype-selection.action.confirm', translationService.language]}}
          </button>
      </sc-actionbar>
  </sc-flex>
</div>
